import React, { useState } from 'react';
import axios from 'axios';
import Layout from "../../../../layout/default";
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import { FaUniversity, FaIdCard, FaMobileAlt, FaUser, FaCheckCircle } from 'react-icons/fa';

const AddBankDetails = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        a_c_holder_name: '',
        account_number: '',
        bank_name: '',
        branch: '',
        ifsc_code: '',
        phone_number: '',
        pancard: '',
        aadharcard: '',

    });

    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setErrors({});
        setMessage('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panRegex.test(formData.pancard)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid PAN Card',
                text: 'PAN format must be 5 letters, 4 digits, and 1 letter (e.g., ABCDE1234F).',
                confirmButtonColor: '#d33'
            });
            return;
        }

        const aadhaarRegex = /^[0-9]{12}$/;
        if (!aadhaarRegex.test(formData.aadharcard)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Aadhaar Number',
                text: 'Aadhaar must be exactly 12 digits.',
                confirmButtonColor: '#d33'
            });
            return;
        }

        try {
            const token = localStorage.getItem('authToken');

            const res = await axios.post(
                `${process.env.REACT_APP_HOST}api/banks`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            // Updated success Swal with the requested style
            Swal.fire({
                imageUrl: "/shop/images/Addbank.svg",
                imageWidth: '100%',
                imageHeight: 'auto',
                imageAlt: "Welcome",
                title: "Bank Details Added Successfully!",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
                customClass: {
                    image: 'full-size-image'
                }
            }).then(() => {
                navigate("/shop/auths/user-profile-page?tab=tabFour");
            });

            setMessage(res.data.message || 'Bank details saved.');
            setErrors({});
            setFormData({
                a_c_holder_name: '',
                account_number: '',
                bank_name: '',
                branch: '',
                ifsc_code: '',
                phone_number: '',
                pancard: '',
                aadharcard: '',
            });

        } catch (error) {
            if (error.response && error.response.status === 422) {
                setErrors(error.response.data.errors || {});
                Swal.fire({
                    icon: 'error',
                    title: 'Validation Error',
                    text: 'Please check the form fields.',
                    confirmButtonColor: '#d33'
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An unexpected error occurred.',
                    confirmButtonColor: '#d33'
                });
                console.error(error);
            }
        }
    };


    return (
        <Layout title="Add Bank Details">
            <Container className="mt-4">
                <Row className="justify-content-md-center">
                    <Col md={8} className="shadow p-4 rounded bg-light">
                        <h4 className="text-center text-primary mb-4">
                            <FaUniversity className="me-2" /> Add Bank Details
                        </h4>

                        {message && <p className="text-success text-center">{message}</p>}

                        <Form onSubmit={handleSubmit}>
                            {/* Row 1: Account Holder Name & Phone Number */}
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaUser className="me-2" /> Account Holder
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="a_c_holder_name"
                                            value={formData.a_c_holder_name}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.a_c_holder_name && (
                                            <div className="text-danger">{errors.a_c_holder_name[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaMobileAlt className="me-2" /> Phone Number
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="phone_number"
                                            value={formData.phone_number}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.phone_number && (
                                            <div className="text-danger">{errors.phone_number[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Row 2: Bank Name & Branch */}
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaUniversity className="me-2" /> Bank Name
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="bank_name"
                                            value={formData.bank_name}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.bank_name && (
                                            <div className="text-danger">{errors.bank_name[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaUniversity className="me-2" /> Branch
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="branch"
                                            value={formData.branch}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.branch && (
                                            <div className="text-danger">{errors.branch[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Row 3: Account Number & IFSC Code */}
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaIdCard className="me-2" /> Account Number
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="account_number"
                                            value={formData.account_number}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.account_number && (
                                            <div className="text-danger">{errors.account_number[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaIdCard className="me-2" /> IFSC Code
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ifsc_code"
                                            value={formData.ifsc_code}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.ifsc_code && (
                                            <div className="text-danger">{errors.ifsc_code[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Row 4: PAN & Aadhar */}
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaIdCard className="me-2" /> PAN Card
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="pancard"
                                            value={formData.pancard}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.pancard && (
                                            <div className="text-danger">{errors.pancard[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            <FaIdCard className="me-2" /> Aadhar Card
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="aadharcard"
                                            value={formData.aadharcard}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.aadharcard && (
                                            <div className="text-danger">{errors.aadharcard[0]}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Submit / Cancel */}
                            <div className="d-grid gap-2 mt-3">
                                <Button variant="primary" type="submit" size="lg">
                                    <FaCheckCircle className="me-2" /> Submit Bank Details
                                </Button>
                                <Button variant="outline-secondary" size="lg" onClick={() => navigate('/shop/auths/user-profile-page?tab=tabFour')}>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <br />
            <br />
            <br />
            <br />
        </Layout>

    );
};

export default AddBankDetails;
